<div #main class="{{disabled ? 'combo-disabled' : ''}}" attr.data-testid="{{testId}}-combobox">

    <div #topLabel *ngIf="label" class="lab {{labelClass}}">
        {{label}}
    </div>

    <div #topSpace *ngIf="label" style="height: 3px;"></div>
    <div [style.background-color]="backgroundColor" #inputArea 
         [style.border-radius]="currencyCombo ? '4px': ''"
         class="inputArea" 
         [ngClass]="{'inputArea-border': hasOutline, 'inputArea-currency-border': currencyCombo}" 
         tabindex="-1" 
         (click)="isReadonly ? null : onInputAreaActivate($event)">
        <table class="comboTable">
            <tr #inputContainer [ngClass]="currencyCombo ? 'input_currency_container' : 'input_container'">
                <ng-container *ngIf="isNewCompany && !currencyCombo">
                    <td style="flex: 1 1 auto">
                        <input #input [width]="getInputWidth"
                               [(ngModel)]="displayValue"
                               [ngClass]="inputTextClass"
                               class="cursor-default {{ isReadonly ? 'readonly-inherit' : ''}}"
                               placeholder="{{hint}}"
                               (focusout)="onFocusOut($event)"
                               attr.data-testid="{{testId}}-combobox-input" />
                    </td>

                    <td #trigger
                        [width]="triggerWidth"
                        class="cursor-default"
                        tabindex="-1"
                        (focusout)="onFocusOut($event)"
                        attr.data-testid="{{testId}}-combobox-picker">
                        <div class="trigger"></div>
                    </td>

                </ng-container>

                <ng-container *ngIf="!isNewCompany && !currencyCombo">

                    <ng-container *ngIf="isImgShowing">
                        <td #firstTd><div class="img"></div></td>
                    </ng-container>

                    <td *ngIf="displayIconCls" id="combo_icon_container">
                        <div class="defaultIconCls {{displayIconCls}}"></div>
                    </td>

                    <td style="flex: 1 1 auto;">
                        <input #input 
                               [width]="getInputWidth"
                               [(ngModel)]="displayValue"
                               [ngClass]="inputTextClass"
                               class="cursor-default {{ isReadonly ? 'readonly-inherit' : ''}}"
                               placeholder="{{hint}}"
                               (focusout)="onFocusOut($event)"
                               (input)="onInput()"
                               attr.data-testid="{{testId}}-combobox-input"/>
                        <span #value id="value"></span>
                    </td>

                    <td #trigger
                        [width]="triggerWidth"
                        class="cursor-default"
                        tabindex="-1"
                        (focusout)="onFocusOut($event)"
                        attr.data-testid="{{testId}}-combobox-picker">
                        <div class="trigger"></div>
                    </td>
                    <!--style=" right: 10px; top: 10px; display: inline-flex; position: relative;"-->
                </ng-container>

                <ng-container *ngIf="!isNewCompany && currencyCombo">
                    <td style="flex: 1 1 auto;">
                        <input #input
                               [width]="30"
                               [(ngModel)]="displayValue"
                               [ngClass]="inputTextClass"
                               class="cursor-default"
                               placeholder="{{hint}}"
                               (focusout)="onFocusOut($event)"
                               (input)="onInput()"
                               attr.data-testid="{{testId}}-combobox-input" />
                        <span #value id="value"></span>
                    </td>

                    <td #trigger
                        [width]="triggerWidth"
                        class="cursor-default"
                        tabindex="-1"
                        (focusout)="onFocusOut($event)"
                        attr.data-testid="{{testId}}-combobox-picker">
                        <div class="trigger"></div>
                    </td>
                </ng-container>
            </tr>


        </table>

    </div>

</div>